import { Link } from "react-router-dom";
import { Heart, Bed, Bath, Maximize, MapPin } from "lucide-react";
import { useEffect, useState } from "react";
import { formatTRY, PROPERTY_TYPE_LABEL, TRANSACTION_LABEL } from "../lib/config";
import { isFavorite, toggleFavorite } from "../lib/favorites";

export const PropertyCard = ({ p, idx = 0 }) => {
  const [fav, setFav] = useState(false);
  useEffect(() => { setFav(isFavorite(p.id)); }, [p.id]);

  const cover = p.images?.[0] || "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?w=1200";
  const coverSrc = cover?.startsWith("http") ? cover : `${process.env.REACT_APP_BACKEND_URL}${cover}`;
  const status = p.status;

  return (
    <article
      data-testid={`property-card-${idx}`}
      className="card-hover group relative bg-white border border-slate-200/70 rounded-2xl overflow-hidden shadow-sm"
    >
      <Link to={`/ilan/${p.slug}`} className="block">
        <div className="aspect-[4/3] overflow-hidden bg-slate-100 relative">
          <img
            src={coverSrc}
            alt={p.title}
            loading="lazy"
            className="img-zoom w-full h-full object-cover"
          />
          <div className="absolute top-4 left-4 flex gap-2">
            <span className={`px-3 py-1 rounded-full text-[11px] font-bold tracking-wider uppercase ${p.transaction_type === "satilik" ? "bg-[#C0562F] text-white" : "bg-slate-900 text-white"}`}>
              {TRANSACTION_LABEL[p.transaction_type]}
            </span>
            {p.featured && (
              <span className="px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider bg-white/95 text-slate-900 backdrop-blur">Öne Çıkan</span>
            )}
            {(status === "satildi" || status === "kiralandi") && (
              <span className="px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider bg-slate-900/80 text-white">
                {status === "satildi" ? "Satıldı" : "Kiralandı"}
              </span>
            )}
          </div>
        </div>
      </Link>

      <button
        onClick={(e) => { e.preventDefault(); setFav(toggleFavorite(p.id)); }}
        aria-label="Favorilere ekle"
        data-testid={`fav-toggle-${idx}`}
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/95 backdrop-blur shadow-md flex items-center justify-center hover:scale-110 transition-transform"
      >
        <Heart className={`w-4 h-4 ${fav ? "fill-[#C0562F] text-[#C0562F]" : "text-slate-700"}`} strokeWidth={1.8} />
      </button>

      <div className="p-5">
        <div className="flex items-center justify-between mb-2">
          <div className="label-caps">{PROPERTY_TYPE_LABEL[p.property_type] || p.property_type}</div>
        </div>
        <Link to={`/ilan/${p.slug}`}>
          <h3 className="font-display text-xl text-slate-900 mb-2 leading-snug group-hover:text-[#C0562F] transition-colors">{p.title}</h3>
        </Link>
        <div className="flex items-center gap-1.5 text-sm text-slate-500 mb-4">
          <MapPin className="w-3.5 h-3.5" />
          <span>{p.district}, {p.city}</span>
        </div>

        <div className="flex items-center gap-5 text-sm text-slate-700 border-t border-slate-100 pt-4">
          {p.room_count && (
            <div className="flex items-center gap-1.5"><Bed className="w-4 h-4 text-slate-500" />{p.room_count}</div>
          )}
          {p.bathroom_count > 0 && (
            <div className="flex items-center gap-1.5"><Bath className="w-4 h-4 text-slate-500" />{p.bathroom_count}</div>
          )}
          {p.net_area > 0 && (
            <div className="flex items-center gap-1.5"><Maximize className="w-4 h-4 text-slate-500" />{p.net_area} m²</div>
          )}
        </div>

        <div className="flex items-end justify-between mt-4">
          <div>
            <div className="text-[11px] tracking-widest uppercase text-slate-400 font-semibold">Fiyat</div>
            <div className="font-display text-2xl text-slate-900">{formatTRY(p.price)}</div>
          </div>
          <Link
            to={`/ilan/${p.slug}`}
            data-testid={`view-details-${idx}`}
            className="text-sm font-semibold text-[#C0562F] hover:text-[#A04726] transition-colors"
          >Detayları Gör →</Link>
        </div>
      </div>
    </article>
  );
};
